import { render } from "./PostDetailsPage.vue?vue&type=template&id=4fe49d70"
import script from "./PostDetailsPage.vue?vue&type=script&lang=js"
export * from "./PostDetailsPage.vue?vue&type=script&lang=js"
script.render = render

export default script